
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../lib/util'
import AbpBase from '../lib/abpbase'
@Component
export default class LanguageSwitch extends AbpBase{
    get languages(){
        return abp.localization.languages.filter(val=>{
            return !val.isDisabled;
        });
    }
    changeLanguage(language){	
        abp.utils.setCookieValue(
            "Abp.Localization.CultureName",
            language.name,
            new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
            abp.appPath
        );
        location.reload();
    }
    get currentLanguageName(){
		
		console.log(abp.utils.getCookieValue("Abp.Localization.CultureName"));
 
        return abp.utils.getCookieValue("Abp.Localization.CultureName");
    }
}
